var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warehouse_info"},[_vm._v("仓库信息")])}
var staticRenderFns = []

export { render, staticRenderFns }